import { Component, Inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";

@Component({
    selector: 'app-schedule-view-restore',
    template: require('./scheduleViewDialogRestore.html')
})
export class ScheduleViewRestoreDialog {

    constructor(@Inject(MAT_DIALOG_DATA) public data: any,
                @Inject(MatDialogRef<ScheduleViewRestoreDialog>) public dialogRef: MatDialogRef<ScheduleViewRestoreDialog>) {
    }

    closeThisDialog(value: any) {
        this.dialogRef.close(value);
    }

}
